import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Stack, Typography } from "@mui/material";
import { isSitePendingSynchronization } from "entities/siteService/sites/shared/utils";
import {
  AutocompleteArrayInput,
  AutocompleteArrayInputProps,
  ReferenceArrayInput,
  ReferenceArrayInputProps,
  useRecordContext,
} from "react-admin";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";

const SiteOption = () => {
  const record = useRecordContext<{
    id: number;
    name: string;
    reported_configuration: any;
  }>();
  if (!record) return null;
  const isPendingSynchronization = isSitePendingSynchronization(record);
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
      <Typography variant="body1" color={isPendingSynchronization ? "error" : "text.primary"}>
        {record.id} - {record.name}
      </Typography>
      {isPendingSynchronization ? (
        <CancelIcon color="error" fontSize="small" />
      ) : (
        <CheckCircleIcon color="success" fontSize="small" />
      )}
    </Stack>
  );
};

const SiteWithPendingSynchronizationAutocomplete = ({
  referenceArrayInputProps,
  autocompleteArrayInputProps,
}: {
  referenceArrayInputProps?: ReferenceArrayInputProps;
  autocompleteArrayInputProps?: AutocompleteArrayInputProps;
}) => {
  return (
    <ReferenceArrayInput
      perPage={100}
      label="Sites"
      source="site_ids"
      reference={SiteResourcesEnum.Sites}
      filter={{ country: SiteContryEnum.France }}
      {...referenceArrayInputProps}
    >
      <AutocompleteArrayInput
        label="Sites"
        getOptionDisabled={(option) => {
          return isSitePendingSynchronization(option);
        }}
        optionText={<SiteOption />}
        inputText={(choice) => choice.name}
        matchSuggestion={(filter, choice) => choice.name.toLowerCase().includes(filter.toLowerCase())}
        helperText="Sites with pending configuration synchronizations are disabled"
        {...autocompleteArrayInputProps}
      />
    </ReferenceArrayInput>
  );
};

export default SiteWithPendingSynchronizationAutocomplete;
